import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cw-widget-setting]'
})
export class WidgetSettingDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/edit-widget-modal/widget-setting.directive.ts